import axios from "axios";
const apiUrl = window._env_?.REACT_APP_BACKEND_URL;

const proApiUrl = window._env_?.API_PRO_URL;
const api = axios.create({
    baseURL: apiUrl,
    timeout: 30000,
});

export const apipro = axios.create({
    baseURL: proApiUrl,
    timeout: 30000,
});

// Add interceptors for handling timeouts
api.interceptors.response.use(
    response => response,
    error => {
        if (error.code === 'ECONNABORTED' || (error.message && error.message.includes('timeout'))) {
            // Handle timeout specifically
            console.error('Request timed out');
            return Promise.reject(new Error('Request timed out. Please try again.'));
        }
        return Promise.reject(error);
    }
);

export default api;





